import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface EditGroupResponse extends MiddlewareAPIResponse
{
    
}

export class EditGroupResponseDtoImpl extends MiddlewareDtoImpl implements EditGroupResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/editgrop/editgroupresponse.tsx